import styled from '@emotion/styled';

export const MainLayout = styled.div`
  text-align: center;
`;
